<ng-template #modalLG let-modal>
  <div class="modal-header" style="background-color: transparent;">
    <button type="button" class="close" (click)="cancelModal()" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body p-0" style="margin: 10px 64px 64px 64px">
    <h3 class="modal-title text-center titre1 " *ngIf="modalType === 'etat'">{{ confirmationMessage }}</h3>
    <h3 class="modal-title text-center titre1" style="margin-bottom: 8px" *ngIf="modalType === 'ajouter'">Ajouter un compte bancaire</h3>
    <h3 class="modal-title text-center titre1" style="margin-bottom: 8px" *ngIf="modalType === 'update'">Modifier un compte bancaire</h3>
    <p class="text-center titre2" *ngIf="modalType === 'ajouter' || modalType === 'update'">
      Remplissez les informations nécessaires pour enregistrer votre compte bancaire.
    </p>

    <form #bankForm="ngForm" (ngSubmit)="onSubmit(bankForm)" *ngIf="modalType !== 'etat'" >
      <div class="form-group">
        <label for="bank">Banque *</label>
        <select class="form-control custom-input" id="bank" name="nom" [(ngModel)]="bankData.nom" required
                [class.is-invalid]="bankForm.controls['nom']?.touched && bankForm.controls['nom']?.errors?.required">
          <option value="">Sélectionnez votre banque</option>
          <option *ngFor="let bank of allBanks" [value]="bank.nom">{{ bank.nom }}</option>
        </select>
        <div class="invalid-feedback" *ngIf="bankForm.controls['nom']?.touched && bankForm.controls['nom']?.errors?.required">
          Le champ banque est obligatoire
        </div>
      </div>

      <div class="row g-3">
        <div class="col-lg-6 m-0" >
          <div class="form-group">
            <label for="designation">Désignation *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="designation"
              name="designation"
              placeholder="Entrez la désignation"
              [(ngModel)]="bankData.designation"
              required
              [class.is-invalid]="bankForm.controls['designation']?.touched && bankForm.controls['designation']?.errors?.required"
            />
            <div class="invalid-feedback" *ngIf="bankForm.controls['designation']?.touched && bankForm.controls['designation']?.errors?.required">
              Le champ Désignation est obligatoire
            </div>
          </div>
        </div>

        <div class="col-lg-6 m-0 " >
          <div class="form-group">
            <label for="agency">Agence *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="agency"
              name="agency"
              placeholder="Entrez l'agence"
              [(ngModel)]="bankData.agence"
              required
              [class.is-invalid]="bankForm.controls['agency']?.touched && bankForm.controls['agency']?.errors?.required"
            />
            <div class="invalid-feedback" *ngIf="bankForm.controls['agency']?.touched && bankForm.controls['agency']?.errors?.required">
              Le champ Agence est obligatoire
            </div>
          </div>
        </div>

        <div class="col-lg-6 m-0 ">
          <div class="form-group">
              <label for="swift">Swift *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="swift"
              name="swift"
              [(ngModel)]="bankData.swift"
              required
              placeholder="Entrez le swift"
              [class.is-invalid]="bankForm.controls['swift']?.touched && bankForm.controls['swift']?.errors?.required"
            />
              <div class="invalid-feedback" *ngIf="bankForm.controls['swift']?.touched && bankForm.controls['swift']?.errors?.required">
                  Le champ Swift est obligatoire
              </div>

          </div>
        </div>

        <div class="col-lg-6 m-0">
          <div class="form-group">

              <label for="iban">IBAN *</label>
            <input
              type="text"
              class="form-control custom-input"
              id="iban"
              name="rib"
              [(ngModel)]="bankData.rib"
              placeholder="Exemple :TN59 1000 6035 1835 9847 8831"
              required
              [class.is-invalid]="bankForm.controls['rib']?.touched && bankForm.controls['rib']?.errors?.required"


            />

              <div class="invalid-feedback" *ngIf="bankForm.controls['rib']?.touched && bankForm.controls['rib']?.errors?.required">
                  Le champ IBAN est obligatoire
              </div>


          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <button type="submit" class="btn btn-primary mr-2" [disabled]="isLoading || !bankForm.valid">
          {{ modalType === 'etat' ? 'Confirmer' : 'Valider' }}
        </button>
        <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="cancelModal()">Annuler</button>
      </div>
    </form>

    <form #etatForm="ngForm" (ngSubmit)="onSubmit(etatForm)" *ngIf="modalType === 'etat'">
      <div class="text-center p-0">
        <p class="titre2">Êtes-vous sûr de vouloir {{ bankData?.statut ? 'désactiver' : 'activer' }} le compte {{ bankData?.nom || 'inconnu' }} ?</p>
        <div class="d-flex justify-content-center">
          <button type="submit" class="btn btn-primary mr-2" [disabled]="isLoading">Confirmer</button>
          <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="cancelModal()" [disabled]="isLoading">Annuler</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
